import * as React from 'react'
import './Navigation.css';
import { connect } from 'react-redux';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';
import { ApplicationState, NavigationState } from "../../../store/index";
import * as MetadataStore from "../../../store/MetadataStore";
import { UserState, actionCreators as userActionCreators } from '../../../store/User';
import { Subscription, SubscriptionStatus, TenantState } from '../../../store/Tenant';
import Sidebar from "../Sidebar";
import ErrorPage from '../../ErrorPage';
import Link from '../../common/Link';
import * as ErrorStore from '../../../store/ErrorStore';
import { bindActionCreators } from 'redux';
import Spinner from '../../common/Spinner';
import NavigationHeader from '../NavigationHeader';
import { NavigationProps } from '../Breadcrumbs';
import { inIframe } from '../../utils/common';

type OwnProps = NavigationProps & {
    allowChangeAccount?: boolean;
};

type ActionProps = {
    userActions: typeof userActionCreators;
    errorActions: typeof ErrorStore.actionCreators;
};

type StateProps = {
    metadata: MetadataStore.MetadataState;
    subscription: Subscription;
    user: UserState;
    tenant: TenantState;
    error: ErrorStore.ErrorState;
    navigation: NavigationState;
};

type Props = OwnProps & StateProps & ActionProps;

class Navigation extends React.Component<Props> {

    componentWillReceiveProps(nextProps: Props) {
        if (this.props.router?.location !== nextProps.router?.location) {
            this.props.errorActions.resetError();
        }
    }

    public render() {
        const { route, router, error, subscription, tenant, navigation } = this.props;

        // there is no subscription on setup tenant screen
        const isExpired = subscription && subscription.status === SubscriptionStatus.Active && Subscription.isExpired(subscription);
        // inIframe is needed for old implementation of teams integration where url in teams tab was store like "project/935f6500-e053-483c-9ce4-f8125f6ec5e9"
        // inIframe == true and navigation.hidden == undefined - old teams tab
        const hideNavigation = !!error.title || route.hideNavigation || (inIframe() && navigation.hidden !== false);

        return <div className={`navigation ${route.disableNavigation ? 'disabled' : ''}`}>
            {
                !route.hideHeader && <NavigationHeader {...this.props} />
            }
            <div className="nav-body">
                {!hideNavigation && <Sidebar />}
                <div className={`nav-content ${(isExpired || tenant.isReadOnly) ? "with-messagebar" : ""}`}>
                    {!route.hideHeader && isExpired
                        && <MessageBar messageBarType={MessageBarType.error}>Your subscription has expired. Please <Link href="/billing">upgrade</Link>.</MessageBar>}
                    {!route.hideHeader && tenant.isReadOnly
                        && <MessageBar messageBarType={MessageBarType.warning}>Your tenant is currently in read-only mode.</MessageBar>}
                    {!route.hideHeader && <StorageWarning tenant={tenant} />}
                    {
                        error.title
                            ? <ErrorPage title={error.title} description={error.description} />
                            : this.props.metadata.isLoading
                                ? <Spinner />
                                : route.component
                                    ? React.createElement(this.props.route.component as any, router as any)
                                    : undefined
                    }
                </div>
            </div>
        </div>;
    }
}

const StorageWarning = ({ tenant }: { tenant: TenantState }) => {
    if (!tenant.storage || tenant.storage.capacity <= 0) {
        return null;
    }

    if (tenant.storage.usage >= tenant.storage.capacity) {
        return <MessageBar messageBarType={MessageBarType.error}>
            The maximum storage capacity for Attachments allowed by your current subscription plan has been reached for this tenant. To continue uploading files, please contact us to either upgrade to a higher-tier plan or purchase additional storage.
        </MessageBar>;
    }

    if (((tenant.storage.usage / tenant.storage.capacity) * 100) >= tenant.storage.usageWarningPercent) {
        return <MessageBar messageBarType={MessageBarType.warning}>
            The storage allocated for Attachments is nearing the maximum allowed by your current subscription plan. To avoid reaching the limit, please contact us to either upgrade to a higher-tier plan or purchase additional storage.
        </MessageBar>;
    }

    return null;
}

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return {
        metadata: state.metadata,
        subscription: state.tenant.subscription,
        user: state.user,
        tenant: state.tenant,
        error: state.error,
        navigation: state.navigation
    };
}

export default connect(
    mapStateToProps, (dispatch): ActionProps =>
({
    userActions: bindActionCreators(userActionCreators, dispatch),
    errorActions: bindActionCreators(ErrorStore.actionCreators, dispatch)
}))(Navigation);